/* eslint-disable */
import * as Yup from 'yup';
import { useState, useEffect, useRef } from 'react';
// material
import {
    Container, Card
} from '@material-ui/core';
import { useFormik, Form, FormikProvider } from 'formik';
import { Stack, TextField, Button } from '@material-ui/core';
import MenuItem from '@material-ui/core/MenuItem';
import { useNavigate } from 'react-router-dom';
import { ToastContainer } from 'react-toastify';
import Divider from '@material-ui/core/Divider';
import TableContainer from '@material-ui/core/TableContainer';
import Table from '@material-ui/core/Table';
import TableHead from '@material-ui/core/TableHead';
import TableRow from '@material-ui/core/TableRow';
import TableCell from '@material-ui/core/TableCell';
import TableBody from '@material-ui/core/TableBody';
import Box from '@material-ui/core/Box';
import CommonPageHeader from '../../../CommonPageModules/CommonPageHeader';
import Page from '../../../Page';
import services from '../Service';
import { getWeek, getYear, lastDayOfWeek, startOfWeek } from 'date-fns';
import _ from 'lodash';
import TokenDecoder from 'src/helpers/TokenDecoder';
import permissionAuth from 'src/utils/permissionAuth';
import Paper from '@material-ui/core/Paper';
import moment from 'moment';
import { trackPromise } from 'react-promise-tracker';
import { LoadingComponent } from 'src/pages/pageLoader';
import ReactToPrint from "react-to-print";
import CreatePDF from './CreatePDF';
import xlsx from 'json-as-xlsx';
import SearchNotFound from '../../../SearchNotFound';

var screenCode = "VIEWCROPFORCAST"

export default function CropForcastView(props) {
    const [csvHeaders, SetCsvHeaders] = useState([]);
    const componentRef = useRef();
    const [group, setGroup] = useState([]);
    const [cropList, setCropList] = useState([]);
    const [collectionCenterList, setCollectionCenterList] = useState([]);
    const [factory, setFactory] = useState([]);
    const [route, setRoute] = useState([]);
    const [product, setProduct] = useState([]);
    const [weekCount, setWeekCount] = useState([]);
    const [monthList, setMonthList] = useState([]);
    const [finalData, setFinalData] = useState([]);
    const [totalRow, setTotalRow] = useState([]);
    const [allTotalRow, setAllTotalRow] = useState(0);
    const [year, setYear] = useState();
    const navigate = useNavigate();
    const [searchClicked, setSearchClicked] = useState(false);
    const [selectedSearchValues, setSelectedSearchValues] = useState({

        groupName: "0",
        factoryName: "0",
        productName: "0"
    });
    const [permissionList, setPermissions] = useState({
        isGroupFilterEnabled: false,
        isFactoryFilterEnabled: false
    });
    const [formData, setFormData] = useState({
        groupID: "0",
        operationEntityID: "0",
        productID: "0"
    });
    const productcatogerySearchSchema = Yup.object().shape({
        groupID: Yup.number().min(1, 'Please Select Group').required('Group Required'),
        operationEntityID: Yup.number().notRequired(),
        productID: Yup.number().notRequired(),
    });

    const formik = useFormik({
        initialValues: {
            groupID: formData.groupID,
            operationEntityID: formData.operationEntityID,
            productID: formData.productID
        },
        validationSchema: productcatogerySearchSchema,
        onSubmit: (values) => {
            trackPromise(SubmitForm(values));
        },
    });

    useEffect(() => {
        if (searchClicked) {
            SubmitForm(values);
        }
    }, [searchClicked]);
    useEffect(() => {
        getPermissions();
    }, []);

    useEffect(() => {
        setFinalData([])
        setValues({
            ...values,
            productID: "0"
        })
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        return () => setSearchClicked(false);
    }, []);

    useEffect(() => {
        setFinalData([])
    }, [formik.values.productID]);

    async function getPermissions() {
        var permissions = await permissionAuth.getPermissionsByScreen(screenCode);
        var isAuthorized = permissions.find(p => p.permissionCode == 'VIEWCROPFORCASTLISTING');

        if (isAuthorized === undefined) {
            navigate('/404');
        }

        var isGroupFilterEnabled = permissions.find(p => p.permissionCode == 'GROUPDROPDOWN');
        var isFactoryFilterEnabled = permissions.find(p => p.permissionCode == 'FACTORYDROPDOWN');

        setPermissions({
            ...permissionList,
            isGroupFilterEnabled: isGroupFilterEnabled !== undefined,
            isFactoryFilterEnabled: isFactoryFilterEnabled !== undefined,
        });

        setValues({
            ...values,
            groupID: parseInt(TokenDecoder.getGroupFactoryToken().group)
        })
        trackPromise(GetAllGroups());
    }

    async function SubmitForm(value) {
        TableHeaderCreation();
        const res = await services.GetViewCropForcastingDetails(value.operationEntityID, value.productID);
        const calRes = res.filter(x => x.quantity > 1)
        let newRes = _.cloneDeep(calRes);
        var result = [];

        newRes.forEach(x => {
            const date = new Date(x.cropForecastDate);
            var weekNumber = getWeek(date);

            var weekID = weekNumber;
            var duplicateDate = result.find(y => y.productID === x.productID && y.factoryName === x.factoryName);

            if (duplicateDate) {
                duplicateDate[weekID] = duplicateDate[weekID] == undefined ? 0 + x.quantity : duplicateDate[weekID] + x.quantity;
                duplicateDate.productName = x.productName;
                duplicateDate.productID = x.productID;
                duplicateDate.factoryName = x.factoryName;
                duplicateDate.total = duplicateDate.total + x.quantity;
            }
            else {
                result.push({
                    [weekID]: x.quantity,
                    productName: x.productName,
                    productID: x.productID,
                    factoryName: x.factoryName,
                    total: x.quantity
                });
            }
        });
        result.sort((a, b) => a.factoryName > b.factoryName ? 1 : -1);
        setFinalData(result)
        calTotalRow(result)
        getSelectedDropdownValuesForReport()
    }

    function TableHeaderCreation() {
        let currentDate = new Date();
        var weekNumber = getWeek(currentDate);
        var newWeekNumber = weekNumber;
        var year = getYear(currentDate);

        const getWeekDates = (year, weekNumber) => {
            const januaryFirst = new Date(year, 0, 1);
            const daysToFirstMonday = (8 - januaryFirst.getDay()) % 7;
            const startDate = new Date(year, 0, 1 + daysToFirstMonday + (weekNumber - 1) * 7);
            const endDate = new Date(startDate);
            endDate.setDate(endDate.getDate() + 6);

            return { startDate, endDate };
        };

        let weeklist = [];
        let weekCount = 0;
        for (let index = 0; index < 12; index++) {
            weekCount = newWeekNumber++;
            const { startDate, endDate } = getWeekDates(year, weekCount);
            weeklist.push({
                weekCount: weekCount,
                WeekStartDate: moment(startDate).format('MMM D'),
                WeekEndDate: moment(endDate).format('MMM D')
            })
        }
        setYear(year)
        let monthlist = [];
        let newWeekCount = 1;
        weeklist.forEach(x => {
            x.weekCount > 52 ? x.weekCount = newWeekCount++ : x.weekCount = x.weekCount
            var d = new Date(currentDate.getFullYear(), 0, 1);
            var months = ["January", "February", "March", "April", "May",
                "June", "July", "August", "September", "October", "November",
                "December"];
            d.setDate(d.getDate() + (x.weekCount * 7));
            monthlist.push({
                monthlist: months[d.getMonth()],
                month: d.getMonth()
            })
        });
        setWeekCount(weeklist);
        var result = [];
        monthlist.forEach(x => {
            var duplicateDate = result.find(y => y.month === x.month);

            if (duplicateDate) {
                duplicateDate.monthlist = x.monthlist;
                duplicateDate.month = x.month;
                duplicateDate.monthCount = ++duplicateDate.monthCount;
            }
            else {
                result.push({
                    monthlist: x.monthlist,
                    month: x.month,
                    monthCount: 1
                });
            }
        });
        setMonthList(result);

        let tempcsvHeaders = [];
        tempcsvHeaders.push({ label: "Fresh Collection Center", value: "factoryName" });
        tempcsvHeaders.push({ label: "Crop", value: "productName" });
        weeklist.forEach(x => {
            tempcsvHeaders.push({ label: x.WeekStartDate + ' - ' + x.WeekEndDate, value: x.weekCount.toString() });
        });
        SetCsvHeaders(tempcsvHeaders);

    }

    function calTotalRow(result) {
        var total = [];
        result.forEach(x => {
            for (var property in x) {
                if (property !== "factoryName" && property !== "productName" && property !== "productID") {
                    total.push({ name: property, value: x[property] });
                }
            }
        });

        const res = Array.from(total.reduce(
            (m, { name, value }) => m.set(name, parseFloat(m.get(name) || 0) + parseFloat(value)), new Map
        ), ([name, value]) => ({ name, value }));
        const allTotal = res.find(x => x.name == 'total')
        setAllTotalRow(allTotal.value)
        setTotalRow(res)
    }

    const { errors, setValues, touched, handleSubmit, isSubmitting, getFieldProps, values } = formik;

    useEffect(() => {
        trackPromise(GetFactoriesByGroupID());
    }, [formik.values.groupID]);

    useEffect(() => {
        trackPromise(GetRouteByFactoryID());
        trackPromise(GetProductDetails());
    }, [formik.values.operationEntityID]);

    useEffect(() => {
        trackPromise(GetProductDetails());
    }, [formik.values.collectionCenterID]);

    async function GetAllGroups() {
        var res = await services.GetAllGroups()
        if (res != null) {
            setGroup(res);
        }
    }

    async function GetFactoriesByGroupID() {
        var res = await services.GetFactoriesByGroupID(formik.values.groupID)
        if (res != null) {
            setFactory(res);
        }
    }

    async function GetRouteByFactoryID() {
        var res = await services.GetRouteByFactoryID(formik.values.operationEntityID)
        if (res != null) {
            setRoute(res);
        }
    }

    async function GetProductDetails() {
        var res = await services.GetAllProductsDetails()
        if (res != null) {
            setProduct(res);
        }
    }

    function clearAll() {
        setValues({
            ...values,
            productID: 0,
            operationEntityID: 0
        })
        setFinalData([]);
    }

    function getSelectedDropdownValuesForReport() {
        var grpname
        {
            group.map((x) => (
                x.groupID == formik.values.groupID ? grpname = x.groupName : null
            ))
        }
        var operationentityname
        {
            factory.map((x) => (
                x.factoryID == formik.values.operationEntityID ? operationentityname = x.factoryName : null
            ))
        }

        var productName
        {
            product.map((x) => (
                x.productID == formik.values.productID ? productName = x.productName : null
            ))
        }

        setSelectedSearchValues({
            ...selectedSearchValues,
            groupName: grpname,
            factoryName: operationentityname,
            productName: productName
        });
    }

    async function createFile() {
        var settings = {
            sheetName: 'Crop Forecast View',
            fileName: 'Crop Forecast View',
            writeOptions: {}
        }
        let newRes = _.cloneDeep(finalData);
        let newCsvHeaders = _.cloneDeep(csvHeaders);
        let newResult = [];
        totalRow.forEach(x => {
            newResult[x.name] = x.value
        })
        newResult['factoryName'] = 'Total'
        newCsvHeaders.push({ label: "Total", value: "total" });
        newRes.push(newResult);
        newRes.push({});

        newRes.push({
            factoryName: selectedSearchValues.groupName == undefined ? 'Group : All Groups' : 'Group :' + selectedSearchValues.groupName,
            productName: selectedSearchValues.factoryName == undefined ? 'Fresh Collection Center : All Fresh Collection Centers' : 'Fresh Collection Center :' + selectedSearchValues.factoryName
        });
        newRes.push({
            factoryName: selectedSearchValues.productName == undefined ? 'Crop : All Crops' : 'Crop :' + selectedSearchValues.productName
        });
        let dataA = [
            {
                sheet: 'Crop Forecast View',
                columns: newCsvHeaders,
                content: newRes
            }
        ]
        xlsx(dataA, settings);
    }

    return (
        <>
            <LoadingComponent />
            <Page title="View Crop Forcast |  FAPS">
                <Container maxWidth>
                    <CommonPageHeader
                        path={"/createCropForcast"}
                        btname="Add"
                        pageName="View Crop Forecasting"
                        leftButtonHidden={true}
                    />
                    <FormikProvider value={formik}>
                        <ToastContainer
                            position="bottom-right"
                            pauseOnHover

                        />
                        <Form autoComplete="off" noValidate onSubmit={handleSubmit}>
                            <Stack spacing={2}>
                                <Stack direction={{ xs: 'column', sm: 'row' }} spacing={2}>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Group *"
                                        value={formik.values.groupID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('groupID')}
                                        error={Boolean(touched.groupID && errors.groupID)}
                                        helperText={touched.groupID && errors.groupID}
                                        InputProps={{
                                            readOnly: !permissionList.isGroupFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> Select Group</MenuItem>
                                        {group.map((option) => (

                                            option.isActive == true ? <MenuItem key={option.groupID} value={option.groupID}>
                                                {option.groupName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Fresh Collection Center "
                                        value={formik.values.operationEntityID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('operationEntityID')}
                                        error={Boolean(touched.operationEntityID && errors.operationEntityID)}
                                        helperText={touched.operationEntityID && errors.operationEntityID}
                                        InputProps={{
                                            readOnly: !permissionList.isFactoryFilterEnabled
                                        }}
                                    >
                                        <MenuItem key={0} value={0}> All Fresh Collection Center</MenuItem>
                                        {factory.map((option) => (
                                            option.isActive == true && option.factoryType == 2 ? <MenuItem key={option.factoryID} value={option.factoryID}>
                                                {option.factoryName}
                                            </MenuItem> : null
                                        ))}
                                    </TextField>
                                    <TextField
                                        select
                                        fullWidth
                                        size="small"
                                        label="Crop "
                                        value={formik.values.productID}
                                        onChange={formik.handleChange}
                                        {...getFieldProps('productID')}
                                        error={Boolean(touched.productID && errors.productID)}
                                        helperText={touched.productID && errors.productID}
                                    >
                                        <MenuItem key={0} value={0}> All Crop</MenuItem>
                                        {product.map((option) => (
                                            <MenuItem key={option.productID} value={option.productID}>
                                                {option.productName}
                                            </MenuItem>
                                        ))}
                                    </TextField>
                                    <Stack direction={{ xs: 'column', sm: 'row' }} justifyContent="right" spacing={2}>
                                        <Button
                                            type="button"
                                            variant="outlined"
                                            color='error'
                                            onClick={() => clearAll()}
                                        > Clear</Button>

                                        <Button
                                            type="submit"
                                            color='secondary'
                                            variant="outlined"
                                        >Search</Button>
                                    </Stack>
                                </Stack>
                            </Stack>

                        </Form>
                    </FormikProvider>
                    <br /><Divider variant="middle" /><br />
                    {finalData.length != 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <TableContainer sx={{ maxHeight: 440 }}>
                                <Table size="small" stickyHeader aria-label="sticky table" border='1px'>
                                    <TableHead>
                                        <TableRow sx={{ border: "2px solid black" }} >
                                            <TableCell align='center' colSpan={2} sx={{ fontWeight: "bold" }} > Year - {year}</TableCell>
                                            {monthList.map((item) => {
                                                var found = weekCount.filter(x => x.WeekEndDate.substring(0, 3) == item.monthlist.substring(0, 3))
                                                if (found.length != 0) {
                                                    return (
                                                        <TableCell sx={{ fontWeight: "bold" }} colSpan={found.length} align='center'>{item.monthlist}</TableCell>
                                                    )
                                                }
                                            })}
                                            <TableCell align='center' rowSpan={3} sx={{ fontWeight: "bold" }} >{'   Total  '}</TableCell>
                                        </TableRow>
                                        <TableRow sx={{ border: "2px solid black" }} >
                                            <TableCell sx={{ top: 38, fontWeight: "bold", minWidth: '10rem' }} align='center' rowSpan={2}>Fresh Collection Center</TableCell>
                                            <TableCell sx={{ top: 38, fontWeight: "bold", minWidth: '10rem' }} align='center' rowSpan={2}>Crop</TableCell>
                                            {weekCount.map((item) => (
                                                <TableCell sx={{ top: 38, fontWeight: "bold", minWidth: '9rem' }} colSpan={1} align='center'>Week - {item.weekCount}</TableCell>
                                            ))}
                                        </TableRow>
                                        <TableRow sx={{ border: "2px solid black" }} >
                                            {weekCount.map((item) => (
                                                <TableCell sx={{ top: 76, fontWeight: "bold" }} colSpan={1} align='center'>{item.WeekStartDate} - {item.WeekEndDate}</TableCell>
                                            ))}
                                        </TableRow>
                                    </TableHead>
                                    <TableBody>
                                        {finalData.map((row) => (
                                            <TableRow sx={{ border: "2px solid black" }} key={row.Farmer}>
                                                <TableCell align='left'> {row.factoryName}</TableCell>
                                                <TableCell align='left'> {row.productName}</TableCell>
                                                {weekCount.map((column) => {
                                                    const value = row[column.weekCount];
                                                    return (
                                                        <TableCell style={{ width: 100 }} align='right'>
                                                            {value == undefined ? '-' : value == 0 ? '-' : parseInt(value) + ' Kg'}
                                                        </TableCell>
                                                    );
                                                })}
                                                <TableCell style={{ width: 100 }} align='right'>
                                                    {row.total == 0 ? '-' : parseInt(row.total) + ' Kg'}
                                                </TableCell>
                                            </TableRow>
                                        ))}
                                        <TableRow sx={{ border: "2px solid black" }}>
                                            <TableCell align='center' style={{ fontWeight: "bold" }} colSpan={2}> Total</TableCell>
                                            {weekCount.map((column) => {
                                                const found = totalRow.find(x => x.name == column.weekCount);
                                                return (
                                                    <TableCell style={{ width: 100, fontWeight: "bold" }} align='right'>
                                                        {found == undefined ? '-' : found.value == 0 ? '-' : parseInt(found.value) + ' Kg'}
                                                    </TableCell>
                                                );
                                            })}
                                            <TableCell style={{ width: 100, fontWeight: "bold" }} align='right'>
                                                {allTotalRow == undefined ? '-' : allTotalRow == 0 ? '-' : parseInt(allTotalRow) + ' Kg'}
                                            </TableCell>
                                        </TableRow>
                                    </TableBody>
                                </Table>
                            </TableContainer>
                        </Box>
                        : <SearchNotFound searchQuery="View Crop Forecasting" />}
                    {finalData.length > 0 ?
                        <Box display="flex" justifyContent="flex-end" p={2}>
                            <Button
                                color="primary"
                                id="btnRecord"
                                type="submit"
                                variant="contained"
                                style={{ marginRight: '1rem' }}
                                onClick={() => createFile()}
                            >
                                EXCEL
                            </Button>
                            <ReactToPrint
                                documentTitle={"Crop Forecast View"}
                                trigger={() =>
                                    <Button
                                        color="primary"
                                        id="btnRecord"
                                        type="submit"
                                        variant="contained"
                                        style={{ marginRight: '1rem', backgroundColor: 'red' }}
                                    >
                                        PDF
                                    </Button>}
                                content={() => componentRef.current}
                            />
                            <div hidden={true}>
                                <CreatePDF ref={componentRef}
                                    finalData={finalData} searchData={selectedSearchValues}
                                    monthList={monthList} weekCount={weekCount} year={year}
                                    totalRow={totalRow} allTotalRow={allTotalRow}
                                />
                            </div>
                        </Box>
                        : null}
                </Container>
            </Page>
        </>
    );
}